module.exports = __webpack_public_path__ + "img/index4.7dc30b83.png";